import React from 'react';
import { Box, Typography } from '@mui/material';
import { Group as GroupIcon } from '@mui/icons-material';
import ShareDialog from '../ShareDialog';
import { shareCustomTab as shareCustomTabAPI, getTabShares } from '../../../services/custom-tab-sharing.service';

const ShareCustomTabDialog = ({
    open,
    onClose,
    customTab,
    onShareSuccess
}) => {
    const handleShare = async (customTabId, selectedUsers, message, isUniversal) => {
        return await shareCustomTabAPI(customTabId, selectedUsers, message, isUniversal);
    };

    const handleLoadShares = async (customTabId) => {
        return await getTabShares(customTabId);
    };

    const renderItemInfo = (item, existingShares) => (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                            <GroupIcon sx={{ color: '#2196f3' }} />
                            <Typography variant="body1" sx={{ color: '#333333', fontSize: '0.9rem' }}>
                Share "{item?.label || 'this custom tab'}" with team members
                            </Typography>
                        </Box>
    );

    return (
        <ShareDialog
            open={open}
            onClose={onClose}
            title="Share Custom Tab"
            item={customTab}
            itemType="CUSTOM_TAB"
            onShare={handleShare}
            onLoadShares={handleLoadShares}
            renderItemInfo={renderItemInfo}
            shareButtonText="Share"
            allowUniversal={true} // Custom tabs support universal access
            onShareSuccess={onShareSuccess}
        />
    );
};

export default ShareCustomTabDialog; 